export default __webpack_public_path__ + "assets/qr-code-advantages-increase-revenue.6e0831b5.svg";